import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type I26PeopleIncRecipeSearchFields = {
  InstanceId?: Field<string>;
};

export type I26PeopleIncRecipeSearchParams = DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type I26PeopleIncRecipeSearchProps = RenderingProps<
  I26PeopleIncRecipeSearchFields,
  I26PeopleIncRecipeSearchParams
>;
